export const getCurrencyPrecision = (currencyCode, precision, customUsdPrecision) => {
    if (currencyCode.toUpperCase() === 'USD') {
        return customUsdPrecision || 3;
    }
    return precision;
};
//# sourceMappingURL=index.js.map